import { render, staticRenderFns } from "./PuzzleHintPanel.vue?vue&type=template&id=72b9e1d8&scoped=true"
import script from "./PuzzleHintPanel.vue?vue&type=script&lang=js"
export * from "./PuzzleHintPanel.vue?vue&type=script&lang=js"
import style0 from "./PuzzleHintPanel.vue?vue&type=style&index=0&id=72b9e1d8&prod&scoped=true&lang=css"
import style1 from "./PuzzleHintPanel.vue?vue&type=style&index=1&id=72b9e1d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9e1d8",
  null
  
)

export default component.exports